import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatToolbar } from '@angular/material/toolbar';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DswAppSwitcherComponent, DswLoginComponent, DswSupportLinkComponent, DswViessmannLogoComponent } from '@vi-succ/design-system-web';
import { AuthService } from '../../services';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [
        MatToolbar,
        TranslateModule,
        RouterLink,
        DswLoginComponent,
        DswAppSwitcherComponent,
        DswSupportLinkComponent,
        DswViessmannLogoComponent,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
    translateService = inject(TranslateService);
    authService = inject(AuthService);
    toggleSidenav = output<void>();

    logout() {
        this.authService.logout();
    }
}
